import {
  Alert,
  Box,
  Button,
  CircularProgress,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { provisioningFormStyles } from "./componentStyles";
import { useState } from "react";
import { provisionShiftOSAccount } from "../apiHelper";
import { useAuth } from "../contexts/AuthContext";

const ShiftOSProvisioningForm = () => {
  const classes = provisioningFormStyles();
  const { getAccessTokenSilently } = useAuth();
  const [provisionMessage, setProvisionMessage] = useState(null);
  const [provisioning, setProvisioning] = useState(false);
  const [formData, setFormData] = useState({
    accountName: "",
    administratorFirstName: "",
    administratorLastName: "",
    administratorEmail: "",
    administratorPhone: "",
    plan: "free",
  });

  return (
    <Box className={classes.outerContainer}>
      <Box className={classes.innerContainer}>
        {provisionMessage && (
          <Box className={classes.messageContainer}>
            <Alert
              severity={provisionMessage === "Successful" ? "success" : "error"}
            >
              {provisionMessage}
            </Alert>
          </Box>
        )}
        <Box className={classes.fieldContainer}>
          <Typography variant="h3">Account Name</Typography>
          <TextField
            variant="standard"
            fullWidth
            placeholder="e.g. ACME Corporation"
            value={formData.accountName}
            onChange={(e) => {
              setFormData({ ...formData, accountName: e.target.value });
            }}
          />
        </Box>
        <Box className={classes.fieldContainer}>
          <Typography variant="h3">Administrator First Name</Typography>
          <TextField
            variant="standard"
            fullWidth
            placeholder="John"
            value={formData.administratorFirstName}
            onChange={(e) => {
              setFormData({
                ...formData,
                administratorFirstName: e.target.value,
              });
            }}
          />
        </Box>
        <Box className={classes.fieldContainer}>
          <Typography variant="h3">Administrator Last Name</Typography>
          <TextField
            variant="standard"
            fullWidth
            placeholder="Smith"
            value={formData.administratorLastName}
            onChange={(e) => {
              setFormData({
                ...formData,
                administratorLastName: e.target.value,
              });
            }}
          />
        </Box>
        <Box className={classes.fieldContainer}>
          <Typography variant="h3">Administrator Email</Typography>
          <TextField
            variant="standard"
            fullWidth
            placeholder="john.smith@acme.com"
            type="email"
            value={formData.administratorEmail}
            onChange={(e) => {
              setFormData({ ...formData, administratorEmail: e.target.value });
            }}
          />
        </Box>
        <Box className={classes.fieldContainer}>
          <Typography variant="h3">Administrator Phone (Optional)</Typography>
          <TextField
            variant="standard"
            fullWidth
            placeholder="+61 400 000 000"
            value={formData.administratorPhone}
            onChange={(e) => {
              setFormData({ ...formData, administratorPhone: e.target.value });
            }}
          />
        </Box>
        <Box className={classes.fieldContainer}>
          <Box className={classes.selectContainer}>
            <Typography variant="h3">Plan</Typography>
            <Select
              variant="standard"
              onChange={(e) => {
                setFormData({ ...formData, plan: e.target.value });
              }}
              value={formData.plan}
              disableUnderline={true}
              MenuProps={{ disablePortal: true }}
              sx={{ width: "100%" }}
            >
              <MenuItem value="free">
                <Box className={classes.optionItemContainer}>Free</Box>
              </MenuItem>
              <MenuItem value="pro">
                <Box className={classes.optionItemContainer}>Pro</Box>
              </MenuItem>
              <MenuItem value="enterprise">
                <Box className={classes.optionItemContainer}>Enterprise</Box>
              </MenuItem>
            </Select>
          </Box>
        </Box>

        <Box className={classes.submitButtonContainer}>
          {provisioning ? (
            <CircularProgress />
          ) : (
            <Button
              onClick={() => {
                getAccessTokenSilently().then((t) => {
                  setProvisioning(true);
                  provisionShiftOSAccount(t, formData)
                    .then((response) => {
                      if (response.success) {
                        setFormData({
                          accountName: "",
                          administratorFirstName: "",
                          administratorLastName: "",
                          administratorEmail: "",
                          administratorPhone: "",
                          plan: "free",
                        });
                        setProvisionMessage("Successful");
                        setProvisioning(false);
                        setTimeout(() => setProvisionMessage(null), 3000);
                      } else {
                        setProvisionMessage(
                          response.message || "Failed, please try again"
                        );
                        setProvisioning(false);
                        setTimeout(() => setProvisionMessage(null), 3000);
                      }
                    })
                    .catch((error) => {
                      console.error("Provisioning error:", error);
                      const errorMessage =
                        error.response?.data?.message ||
                        error.message ||
                        error.response?.statusText ||
                        "Failed, please try again";
                      setProvisionMessage(errorMessage);
                      setProvisioning(false);
                      setTimeout(() => setProvisionMessage(null), 5000);
                    });
                });
              }}
            >
              Submit
            </Button>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ShiftOSProvisioningForm;
